import {
  Gamepad2, Users, Skull, Trophy, Swords, Clock, Shield,
  Target, Zap, Star, Crown, Award, DollarSign, TrendingUp
} from 'lucide-react';

export const MODE_ICONS = {
  classic: Gamepad2, coop_campaign: Users, survival: Skull,
  versus_score: Trophy, boss_rush: Swords, time_attack: Clock,
  last_stand: Shield, high_score: Trophy
};

export const MODE_COLORS = {
  classic: '#14F195', coop_campaign: '#9945FF', survival: '#FF3B30',
  versus_score: '#FFD700', boss_rush: '#FF6B00', time_attack: '#00BFFF',
  last_stand: '#8B5CF6', high_score: '#FFD700'
};

// Map achievement icon names from the backend to lucide-react components
export const BADGE_ICONS = {
  skull: Skull, target: Target, zap: Zap, star: Star, crown: Crown,
  trophy: Trophy, gamepad: Gamepad2, swords: Swords, dollar: DollarSign,
  trending: TrendingUp, shield: Shield, award: Award
};

export const RARITY_STYLES = {
  common:    { color: '#A1A1AA', glow: 'rgba(161,161,170,0.25)', label: 'Common' },
  uncommon:  { color: '#5AC8FA', glow: 'rgba(90,200,250,0.30)',  label: 'Uncommon' },
  rare:      { color: '#14F195', glow: 'rgba(20,241,149,0.35)',  label: 'Rare' },
  epic:      { color: '#9945FF', glow: 'rgba(153,69,255,0.40)',  label: 'Epic' },
  legendary: { color: '#FFD700', glow: 'rgba(255,215,0,0.45)',   label: 'Legendary' },
  mythic:    { color: '#FF4500', glow: 'rgba(255,69,0,0.55)',    label: 'Mythic' },
};

export const formatAddr = (a) => {
  if (!a) return 'Unknown';
  if (a.startsWith('guest_')) return a.slice(0, 12);
  return `${a.slice(0, 4)}...${a.slice(-4)}`;
};

export const formatDate = (d) => {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};
